import React from 'react';

import Money from '@components/Gui/Money';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * PayableBalances
 *
 * Displays balance boxes for payable statements (on hold, total, available)
 */
const PayableBalances = ({ onHoldBalances, totalBalances, availableBalances }) => {
    return (
        <>
            <div className="statement-total-header">
                <div className="statement-total-header-icon">
                    <NwIcon icon={byPrefixAndName.fasl['piggy-bank']} />
                </div>
                <div className="statement-total-header-text">
                    <h3>Current balances</h3>
                </div>
            </div>
            {onHoldBalances && (
                <div className="statement-total-box margin-left-auto statement-total-box-on-hold">
                    <div className="statement-total-box-icon">
                        <NwIcon icon={byPrefixAndName.fasl['circle-pause']} />
                    </div>
                    <div className="statement-total-box-text">
                        <p>on hold</p>
                        <small>&nbsp;</small>
                    </div>
                    <div className="statement-total-box-values">
                        {Object.entries(onHoldBalances).map(([currency, amount]) => (
                            <p key={currency}>
                                <Money amount={amount} currency={currency} redIfNegative boldIfDefaultCurrency />
                            </p>
                        ))}
                    </div>
                </div>
            )}
            <div className={`statement-total-box ${!onHoldBalances ? 'margin-left-auto' : ''}`}>
                {/* <div className="statement-total-box-icon">
                    <NwIcon icon={byPrefixAndName.fasl['chart-line']} />
                </div> */}
                <div className="statement-total-box-text">
                    <p>total</p>
                    <small>including unpaid jobs</small>
                </div>
                <div className="statement-total-box-values">
                    {Object.entries(totalBalances).map(([currency, amount]) => (
                        <p key={currency}>
                            <Money amount={amount} currency={currency} redIfNegative boldIfDefaultCurrency />
                        </p>
                    ))}
                </div>
            </div>
            <div className="statement-total-box">
                {/* <div className="statement-total-box-icon">
                    <NwIcon icon={byPrefixAndName.fasl['piggy-bank']} />
                </div> */}
                <div className="statement-total-box-text">
                    <p>available</p>
                    <small>jobs paid by client, expenses</small>
                </div>
                <div className="statement-total-box-values">
                    {Object.entries(availableBalances).map(([currency, amount]) => (
                        <p key={currency}>
                            <Money amount={amount} currency={currency} redIfNegative boldIfDefaultCurrency />
                        </p>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PayableBalances;
